import { call, put, takeEvery } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import { Download } from "../../../helpers/download";
import {
  eTongHopHocPhiActionIds,
  ITongHopHocPhiActions,
} from "../../action-types/tong-hop/ITongHopHocPhiActions";
import { ITongHopHocPhiRequest } from "../../reducer-model/tong-hop/ITongHopHocPhiReducer";
import { tongHopHocPhiApi } from "../../../api/tong-hop/tongHopHocPhiApi";

const mainAction = rootActions.tongHop.hocPhi;
export function* tongHopHocPhi(): any {
  yield takeEvery(
    eTongHopHocPhiActionIds.EXPORT_EXCEL_START,
    exportExcelWorker
  );
}

function* exportExcelWorker(action: ITongHopHocPhiActions): any {
  const res: IBaseRespone = yield call(
    tongHopHocPhiApi.ExportExcel,
    action.payload as ITongHopHocPhiRequest
  );
  if (res.is_success) {
    Download.Excel(res.data, "tong_hop_hoc_phi.xlsx");
    yield put(mainAction.EXPORT_EXCEL_SUCCESS("Thành công!"));
  } else {
    yield put(mainAction.EXPORT_EXCEL_ERROR(res.message ?? "Có lỗi"));
  }
}
